var map = {
	"./'21073101' , 2021, oil on canvas, 12 x 12 in. (30.48 x 30.48 cm), P.JPG": 8625,
	"./'Antique Picture', 2025, oil on canvas, 14 x 11 in. (35.56 x 27.94 cm).jpg": 3858,
	"./'Autumn Sky', 2023, oil on canvas, 12 x 24 in. (30.48 x 60.96 cm).JPG": 5190,
	"./'Barrington Afternoon Sky' , 2024, oil on canvas, 12 x 12 in. (30.48 x 30.48 cm).JPG": 6996,
	"./'By the pond' , 2024, oil on canvas, 12 x 12 in. (30.48 x 30.48 cm).JPG": 9736,
	"./'Calm Reflection', 2025, oil on canvas, 11 x 14 in. (27.94 x 35.56 cm).jpg": 2345,
	"./'Cloud Light' , 2025, oil on canvas, 30 x 24 in. (76.20 x 60.96 cm), P.jpeg": 5786,
	"./'Cloudy Sunrise' , 2023, oil on canvas, 20 x 24 in. (50.8 x 60.96 cm), P.jpeg": 5027,
	"./'Crisp Autumn Day', 2025, oil on canvas, 15 x 30 in. (38.10 x 76.20 cm).JPG": 3247,
	"./'Early Spring in Illinois', 2025, oil on canvas, 9.45 x 12.99 in. (24 x 33 cm).jpg": 3440,
	"./'First Evening Star', 2025, oil on canvas, 15 x 30 in. (38.10 x 76.20 cm).jpeg": 6058,
	"./'Flowery Field' , 2024, oil on canvas, 24 x 24 in. (60.96 x 60.96 cm), P.JPG": 449,
	"./'Fresh Green Swamp', 2025, oil on canvas, 12 x 24 in. (30.48 x 60.96 cm), P.JPG": 1826,
	"./'Going Home', 2024, oil on canvas, 9.45 x 12.99 in. (24 x 33 cm), P.JPG": 8061,
	"./'Golden Sunrise' , 2025, oil on canvas, 10 x 30 in. (25.40 x 76.20 cm).jpg": 9525,
	"./'Heading Home', 2023, oil on canvas, 22 x 28 in. (55.88 x 71.12 cm), P.JPG": 2060,
	"./'Heavenly Meadow', 2025, oil on canvas, 14 x 11 in. (35.56 x 27.94 cm), P.jpg": 2426,
	"./'Honest Reflection', 2025, oil on canvas, 12 x 24 in. (30.48 x 60.96 cm), P.jpg": 6622,
	"./'Hope Rising' , 2025, oil on canvas, 8 x 10 in. (20.32 x 25.40 cm).jpeg": 8375,
	"./'Indian Summer' , 2024, oil on canvas, 12 x 24 in. (30.48 x 60.96 cm), P.JPG": 8738,
	"./'January Sunrise' , 2024, oil on canvas, 12 x 12 in. (30.48 x 30.48 cm), P.JPG": 4206,
	"./'Late Autumn Swamp', 2025, oil on canvas, 15 x 30 in. (38.10 x 76.20 cm), P.JPG": 3044,
	"./'Late Winter Sky' , 2024, oil on canvas, 12 x 24 in. (30.48 x 60.96 cm), P.JPG": 5594,
	"./'Lavender Clouds over the Marsh', 2024, oil on canvas, 12 x 24 in. (30.48 x 60.96 cm), P.JPG": 9895,
	"./'Midwinter Dusk', 2024, oil on canvas, 12 x 24 in. (30.48 x 60.96 cm), P.JPG": 1208,
	"./'Mirrored Grace' , 2025, oil on canvas, 12 x 12 in. (30.48 x 30.48 cm).jpeg": 4138,
	"./'Morning Field' , 2024, oil on canvas, 10 x 20 in. (xx.xx x xx.xx cm).JPG": 6782,
	"./'Morning Waves', 2024, oil on canvas, 15 x 30 in. (38.10 x 76.20 cm), P.JPG": 5841,
	"./'Near Ellison Bay', 2023, oil on canvas, 24 x 24 in. (60.96 x 60.96 cm), P.JPG": 4782,
	"./'Near Sturgeon Bay' , 2024, oil on canvas, 24 x 24 in. (60.96 x 60.96 cm), P.JPG": 8254,
	"./'New Horizon' , 2024, oil on canvas, 24 x 24 in. (60.96 x 60.96 cm).JPG": 1878,
	"./'One Spring Day' , 2023, oil on canvas, 12 x 12 in. (30.48 x 30.48 cm).JPG": 2983,
	"./'One Summer Day' , 2024, oil on canvas, 24 x 24 in. (60.96 x 60.96 cm), P.jpg": 9585,
	"./'Peaceful View' , 2024, oil on canvas, 14 x 14 in. (35.56 x 35.56 cm).JPG": 979,
	"./'Perfect Blue', 2024, oil on canvas, 12 x 24 in. (30.48 x 60.96 cm), P.JPG": 9587,
	"./'Rolling Waves', 2025, oil on canvas, 12 x 24 in. (30.48 x 60.96 cm).JPG": 1276,
	"./'Sea of Green', 2025, oil on canvas, 10 x 20 in. (25.40 x 50.80 cm).JPG": 7930,
	"./'Sunrise Over Water' , 2024, oil on canvas, 20 x 16 in. (50.8 x 40.64 cm).JPG": 6627,
	"./'Sunset at Fish Creek', 2023, oil on canvas, 24 x 24 in. (60.96 x 60.96 cm).JPG": 9981,
	"./'Sunset on the Horizon', 2024, oil on canvas, 9.45 x 12.99 in. (24 x 33 cm).JPG": 7047,
	"./'The Perfect Spot' , 2025, oil on canvas, 6 x 8 in. (15.24 x 20.32 cm).jpeg": 3213,
	"./'Timberlake Sunset', 2024, oil on canvas, 12 x 24 in. (30.48 x 60.96 cm), P.JPG": 1154,
	"./'Tranquillity', 2025, oil on canvas, 14 x 14 in. (35.56 x 35.56 cm).jpg": 8361,
	"./'Twilight Glow', 2025, oil on canvas, 12 x 24 in. (30.48 x 60.96 cm), P.jpg": 4299,
	"./'Unexpected Light', 2025, oil on canvas, 10 x 20 in. (25.40 x 50.80 cm).jpeg": 8106,
	"./'Warmth of the Sun', 2025, oil on canvas, 14 x 14 in. (35.56 x 35.56 cm), P.jpg": 2282,
	"./'Windy Day', 2024, oil on canvas, 12 x 24 in. (30.48 x 60.96 cm), P.JPG": 1859,
	"./'Winter Pond', 2024, oil on canvas, 8 x 6 in. (20.32 x 15.24 cm), P.JPG": 7760,
	"./'Winter beach', 2024, oil on canvas, 12 x 24 in. (30.48 x 60.96 cm), P.JPG": 5246
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5304;